class BrowserSize extends HTMLElement {
  /** @type {number | null} */
  resizeFrameId = null;

  connectedCallback() {
    this.updateSize();

    this.handleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);

    if (this.resizeFrameId) {
      cancelAnimationFrame(this.resizeFrameId);
      this.resizeFrameId = null;
    }
  }

  updateSize() {
    this.textContent = `${window.innerWidth}x${window.innerHeight}`;
  }

  handleResize() {
    if (this.resizeFrameId) return;

    this.resizeFrameId = requestAnimationFrame(() => {
      this.updateSize();
      this.resizeFrameId = null;
    });
  }
}

if (!customElements.get('browser-size')) {
  customElements.define('browser-size', BrowserSize);
}
